import React from 'react';
import { useParams } from 'react-router';
import { useLocation } from 'react-router-dom';

export const withRouteParams = (Component) => function (props)
{
    const params = useParams();
    const location = useLocation();

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Component params={params} {...props} router={{ location }} />;
};
